import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { touchOptimizedStyles } from "shared/components/common/base-link/styles";
import { fontRoboto, theme } from "shared/lib/styles";

import type { LoginDialog } from "./atoms";
import ScmpLogo from "./scmp-logo.svg";

type ContainerProps = {
  $variant?: LoginDialog["variant"];
};

export const Container = styled.div<ContainerProps>`
  position: relative;

  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;

  inline-size: 100vw;
  block-size: 100vh;
  max-inline-size: 400px;
  margin: auto;

  border-radius: 8px;

  background-color: #f6f6f6;

  outline: none;

  ${theme.breakpoints.up("mobile")} {
    max-block-size: 667px;
  }

  ${props =>
    props.$variant === "dialog-with-primary-close-button-only"
      ? css`
          inline-size: calc(100vw - 40px);
          max-inline-size: 400px;
          padding: 32px;

          ${theme.breakpoints.up("mobile")} {
            block-size: min-content;
          }
        `
      : null}
`;

export const CloseButton = styled.button`
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;

  inline-size: 60px;
  block-size: 60px;
  padding: 20px;

  background-color: transparent;

  cursor: pointer;

  ${touchOptimizedStyles};
`;

export const StyledScmpLogo = styled(ScmpLogo)`
  inline-size: 47px;
  block-size: 36px;
  margin-block-start: 20px;

  ${theme.breakpoints.up("mobile")} {
    margin-block-start: 52px;
  }
`;

export const LoginForm = styled.div`
  padding-block: 0;
  padding-inline: 64px;

  & #sa-login-widget-title {
    margin-block: 24px;
  }
`;

export const PrimaryCloseButton = styled.div`
  display: flex;
  justify-content: center;

  inline-size: 270px;
  margin-block-start: 24px;
  padding-block: 12px;

  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRoboto};
  text-transform: uppercase;

  background-color: #ffca05;

  cursor: pointer;
`;

export const Disclaimer = styled.div`
  inline-size: 270px;
  max-inline-size: 320px;
  margin-block-start: auto;
  padding-block: 24px;
  padding-inline: 0;

  color: #999999;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
  text-align: center;

  & a {
    display: inline;

    color: #999999;
    font-size: 12px;
    font-family: ${fontRoboto};
    text-decoration: underline;
  }
`;
